import React, { PureComponent, MouseEvent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import DataGrid, { Paging, HeaderFilter,Search, FilterRow, Column, Export, FilterPanel, GroupPanel, Pager, SearchPanel, StateStoring, Scrolling, Selection } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import { buildRequestParameters } from "../../services/RemoteOperationsService";
import sharedUtils from "../grid/sharedUtilities";
import QueryService, { queryStatusType, queryTypes } from "../../services/QueryService";
import LookupService, { LookupTypeIndexes, LookupTypeItem } from "../../services/LookupService";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFileAlt, faPen, faCheckDouble, faSquare, faBell, faBellSlash, faCheck } from "@fortawesome/pro-regular-svg-icons";
import { ScrollView, Popup, LoadPanel, SelectBox, TextArea, TextBox } from "devextreme-react";
import queryUtils, { QueryFormObject } from "../Query/QueryUtils";
import { alert, confirm } from "devextreme/ui/dialog";
import { TextBoxOnValueChangedEvent, DataGridOnSelectionChanged, SelectBoxOnValueChangedEvent } from "../../types/DevExtremeTypes";
import DropDownFromLookupTable from "../select/SelectBoxFromLookupTable";
import QuickAddShiftForm from "../QuickAddShift/QuickAddShiftForm"
import TagCell from "../GigRequest/TagCell";
import CookieService, { DXGridCookieKeyTypes } from "../../services/CookieService";
import SupplierInformationMainContent from "../SupplierInformation/SupplierInformationMainContent";
import ArtistProfileComponent from "../Artist-Profile/ArtistProfileComponent";
import notify from "devextreme/ui/notify";
import QueryManageForm from "./QueryManageForm";
import QueryGridRenderDataRow from "./QueryGridRenderDataRow";
import ClientInformationMainContent from "../ClientInformation/ClientInformationMainContent";
import { onExportingEvent } from "../../types/DevExtremeTypes";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";

let billableItemId: string = "";
let queryFormId: string = "";

interface QueryActivityItem {
    id: string | null;
    query_Id: string;
    activity_Comments: string;
    activity_Type: string;
    activity_LastUpdatedBy: string;
    activity_LastUpdated: string;
    activity_external: boolean;
    activity_RaisedBy?: string;
}

interface QueryGridProps extends WithTranslation {
    statusId: string;
    serviceTypeId: string;
    venueId: string;
    clientId: string;
    location: any;
    history?: any;
    navigateFrom?: string;
    queryId?: string;
    contactId?: string;
    raisedById?:string;
    isRefreshButtonClicked?:boolean
    onRefresh?: (flag: boolean) => void;
}

interface QueryGridState {
    dataSource: [],
    titlePopupVisible: boolean;
    title: string;
    internalCommentsPopupVisible: boolean;
    internalComments: string;
    resolutionReasonPopUpVisible: boolean;
    resolutionReason: string;
    loadIndicatorForGrid: boolean;
    resolveQueryItem: QueryFormObject;
    onQueryRaising: boolean;
    loadPanelVisible: boolean;
    isVisibleManageShiftPopup: boolean;
    isVisibleQueryPopup: boolean;
    billableItemId: string;
    isPopupVisible: boolean;
    providerPopupVisibleOther: boolean;
    providerPopupVisibleEntertainment: boolean;
    clientId: string;
    venueId: string;
    businessEntityId: string;
    serviceId: string;
    isDisabled: boolean;
    venuePopupVisible:boolean;
    serviceName : string;
    providerType:string;
    newActivityPopupVisible: boolean;
    selectedQueryIdForActivity: string;
    activityItems: QueryActivityItem[];
    activityPopupLoading: boolean;
    queryCategoryLookUp: LookupTypeItem[];
    queryResolutionCategoryLookUp: LookupTypeItem[];
    resolveQueryCategory: string;
    resolveQueryCategoryOther: string;
    resolveResolutionCategory: string;
    resolveResolutionCategoryOther: string;
}

// PureComponent: when embedded in QueryManageForm, every form edit would otherwise re-render the linked queries grid.
class QueryGrid extends PureComponent<QueryGridProps> {
    state: QueryGridState;
    queryService: QueryService;
    sharedUtils: sharedUtils;
    queryUtils: queryUtils;
    lookupService: LookupService;
    remoteOperations: {
        sorting: boolean;
        paging: boolean;
        filtering: boolean;
        grouping: boolean;
        summary: boolean;
    }
    isEditMode: string;
    dataGrid:any;
    otherdataGrid:any;
    clearRef:any;
    filterQueryCategoryLookUp: (items: LookupTypeItem[], appId: string) => LookupTypeItem[];
    filterQueryResolutionCategoryLookUp: (items: LookupTypeItem[], appId: string) => LookupTypeItem[];
    // Grid options are kept as stable references: devextreme-react compares props with ===, so inline
    // objects/arrays/functions push column updates to the DataGrid on every render (e.g. each popup keystroke).
    gridElementAttr = { id: "gridContainer" };
    allowedPageSizes = [5, 10, 20];
    resolvePopupWrapperAttr = { class: "pop-up pop-up--resolve pop-up--left-aligned" };
    newActivityHeaderFilter = {
        dataSource: [
            { text: "New Activity", value: ["newActivity", "=", true] },
            { text: "No New Activity", value: [["newActivity", "=", false], "or", ["newActivity", "=", null]] }
        ]
    };
    constructor(props: QueryGridProps) {
        super(props);
        this.dataGrid = null;
        this.otherdataGrid = null;
        this.queryUtils = new queryUtils();
        this.filterQueryCategoryLookUp = this.queryUtils.createCategoryLookupFilter();
        this.filterQueryResolutionCategoryLookUp = this.queryUtils.createCategoryLookupFilter();
        let convertedResolveQueryFormData = this.queryUtils.initializeQueryItem(
            ""
        );
        this.isEditMode = "";
        this.state = {
            dataSource: [],
            isPopupVisible: false,
            titlePopupVisible: false,
            title: "",
            internalCommentsPopupVisible: false,
            internalComments: "",
            resolutionReasonPopUpVisible: false,
            resolutionReason: "",
            onQueryRaising: false,
            loadIndicatorForGrid: false,
            resolveQueryItem: convertedResolveQueryFormData,
            loadPanelVisible: false,
            isVisibleManageShiftPopup: false,
            isVisibleQueryPopup: false,
            billableItemId: "",
            providerPopupVisibleOther: false,
            providerPopupVisibleEntertainment: false,
            clientId: this.props.clientId,
            venueId: this.props.venueId,
            businessEntityId: "",
            serviceId: "",
            isDisabled: true,
            venuePopupVisible:false,
            serviceName : '',
            providerType:'',
            newActivityPopupVisible: false,
            selectedQueryIdForActivity: "",
            activityItems: [],
            activityPopupLoading: false,
            queryCategoryLookUp: [],
            queryResolutionCategoryLookUp: [],
            resolveQueryCategory: "",
            resolveQueryCategoryOther: "",
            resolveResolutionCategory: "",
            resolveResolutionCategoryOther: ""
        }
        this.queryService = new QueryService();
        this.lookupService = new LookupService();
        this.sharedUtils = new sharedUtils();
        this.remoteOperations = {
            sorting: true,
            filtering: true,
            grouping: true,
            paging: true,
            summary: false
        }
        this.clearRef = React.createRef;
        this.clearRef.current = false;
    }

    isNavigateFromPendingQueries = () =>{
        let isPendingQueries = false;
        let navigateFrom = this.props.location?.state && this.props.location?.state?.navigateFrom || '';
        if (navigateFrom == "PendingQueries_JustPay" || navigateFrom == "PendingQueries_EventUK" || navigateFrom == "PendingQueries_Other") {
           isPendingQueries = true;
        }
        return isPendingQueries;
    }

    componentDidMount() {
        this.setState({
            loadIndicatorForGrid: true
        });
        let navigateFrom = this.props.location?.state && this.props.location?.state?.navigateFrom || '';
        if (this.isNavigateFromPendingQueries()) {
            this.clearRef.current = true;
        }
        this.lookupService
            .getLookupByLookupTypeIndexAll(LookupTypeIndexes.queryCategory)
            .then(this.handleQueryCategoryLookupSuccess)
            .catch(() => undefined);
        this.lookupService
            .getLookupByLookupTypeIndexAll(LookupTypeIndexes.queryResolutionCategory)
            .then(this.handleQueryResolutionCategoryLookupSuccess)
            .catch(() => undefined);
    }

    handleQueryCategoryLookupSuccess = (response: any) => {
        const lookupData = response?.data;
        const items = Array.isArray(lookupData)
            ? lookupData
            : (Array.isArray(lookupData?.data) ? lookupData.data : []);
        this.setState({ queryCategoryLookUp: items });
    }

    handleQueryResolutionCategoryLookupSuccess = (response: any) => {
        const lookupData = response?.data;
        const items = Array.isArray(lookupData)
            ? lookupData
            : (Array.isArray(lookupData?.data) ? lookupData.data : []);
        this.setState({ queryResolutionCategoryLookUp: items });
    }

    clearFiltersOnLoad_DrillDown = () => {
        //this.clearRef.current = true;
        let navigateFrom = this.props.location.state && this.props.location.state.navigateFrom || '';
        if(navigateFrom && this.clearRef?.current && (this.isNavigateFromPendingQueries())){
                this.otherdataGrid?.instance()?.clearFilter();
                this.clearRef.current = false;
        }
    }


    getResults = (loadOptions: any) => {
        this.clearFiltersOnLoad_DrillDown();
        let params = buildRequestParameters(loadOptions);
        if(this.props.raisedById){
            let raisedId = parseInt(this.props.raisedById);
            let filters = ["businessEntity.businessEntityTypeLookUpId","=",raisedId];
            params = buildRequestParameters(loadOptions,'filter',filters);
        }

        if(this.props.navigateFrom == "queryform"){
            let queryId = this.props?.queryId ? this.props?.queryId : "";
            let contactId = this.props?.contactId ? this.props?.contactId : "";
            let linkedParams = params + `&queryId=${queryId}&contactId=${contactId}`;
            return this.queryService.linkedQueryData(linkedParams)
                .then((response) => {
                    return this.handleSuccessDataSource(response)
                })
                .catch(() => { throw 'Data Loading Error'; });
        }
        else{
            // if (this.props.location && this.props.location.state && this.props.location.state.navigateFrom == "PendingQueries") {
            //      if(params !== "") params = params + `&serviceTypeId=${this.props.location.state.serviceType}&status=${this.props.statusId}&clientId=&venueId=&navigatefrom=pendingqueries`;
            //     else params = params + `?serviceTypeId=${this.props.location.state.serviceType}&status=${this.props.statusId}&clientId=&venueId=&navigatefrom=pendingqueries`;
            // }
            if (this.props.location && this.props.location.state && this.isNavigateFromPendingQueries()) {
                if (params) {
                    params += `&`;
                } else {
                    params += `?`;
                }
                params+= `serviceTypeId=${this.props.location.state.serviceType}&status=&clientId=&venueId=&navigatefrom=pendingqueries`;

                // if(params !== "") params = params + `&serviceTypeId=${this.props.location.state.serviceType}&status=${this.props.statusId}&clientId=&venueId=&navigatefrom=pendingqueries`;
                // else params = params + `?serviceTypeId=${this.props.location.state.serviceType}&status=${this.props.statusId}&clientId=&venueId=&navigatefrom=pendingqueries`;
            }
            else if (this.props.location && this.props.location.state && this.props.location.state.navigateFrom == "shiftMatrix") {
                this.otherdataGrid?.instance()?.clearFilter(); // to clear the already added filters
                if(params !== "") params = params + `&serviceTypeId=&status=${this.props.statusId}&filter=[%22case_ID%22,%22=%22,${this.props.location.state.queryId}]&clientId=&venueId=`;
                else params = params + `?serviceTypeId=&status=${this.props.statusId}&filter=[%22case_ID%22,%22=%22,${this.props.location.state.queryId}]&clientId=&venueId=`;
            }
            else if (params) {
                if(params !== "") params = params + `&serviceTypeId=${this.props.serviceTypeId}&status=${this.props.statusId}&clientId=${this.props.clientId}&venueId=${this.props.venueId}`;
                else params = params + `?serviceTypeId=${this.props.serviceTypeId}&status=${this.props.statusId}&clientId=${this.props.clientId}&venueId=${this.props.venueId}`;
            }
            else {
                params = `?serviceTypeId=${this.props.serviceTypeId}&status=${this.props.statusId}&clientId=${this.props.clientId}&venueId=${this.props.venueId}`;
            }
            return this.queryService.getQueryGridRowsWithinRemoteOperations(params)
                .then((response) => {
                    return this.handleSuccessDataSource(response)
                })
                .catch(() => { 
                    //this.props.onRefresh ? this.props.onRefresh(false) :null;
                    throw 'Data Loading Error'; 
            });
        }

    }
    handleSuccessDataSource = (response: any) => {
        this.setState({
            loadIndicatorForGrid: false
        });
        //this.props.onRefresh ? this.props.onRefresh(false) :null;
        return {
            data: response.data.data ? response.data.data : [],
            totalCount: response.data.totalCount
        };
    }


    componentDidUpdate(prevpros: QueryGridProps) {
        if (prevpros.statusId != this.props.statusId || prevpros.serviceTypeId != this.props.serviceTypeId 
            || prevpros.clientId != this.props.clientId || prevpros.venueId != this.props.venueId 
            || prevpros.queryId != this.props.queryId || prevpros.contactId != this.props.contactId
            || prevpros.raisedById != this.props.raisedById || (this.props.isRefreshButtonClicked != prevpros.isRefreshButtonClicked && this.props.isRefreshButtonClicked == true)) {
            this.loadDataSource();
            this.props.onRefresh ? this.props.onRefresh(false) :null;
        }
        else {
            return false;
        }
    }


    loadDataSource = () => {
        let dataSource = new CustomStore({
            key: "case_ID",
            load: this.getResults,
        });
        this.setState({
            dataSource: dataSource
        });

    }
    showRelatedItemPopup = (itemId: string) => {
        billableItemId = itemId;
        this.setState({
            isVisibleManageShiftPopup: true
        });
    }    

    closeManageShiftPopup = () => {
        billableItemId="";
        this.setState({
            isVisibleManageShiftPopup: false
        });
    }

    showQueryFormPopup = (itemId: string) => {
        queryFormId = itemId;
        this.setState({
            isVisibleQueryPopup: true
        });
    }

    closeQueryFormPopup = () => {
        queryFormId="";
        this.setState({
            isVisibleQueryPopup: false
        });
    }

    handleResolveOnClick = (rowInfo: any) => {
        if (rowInfo.data.caseStatusLU.case_Status_ID && rowInfo.data.caseStatusLU.case_Status_ID != queryStatusType.Resolved) {
            this.setState({
                loadPanelVisible: true
            });
            this.queryService.getQueryCardItem(rowInfo.data.case_ID)
                .then(this.handleResolveQueryLoadSuccess)
                .catch(this.handleResolveQueryLoadFailure);
        }
    }

    /**
     * Loads the full query record so the Resolve popup matches the Query Manage Form values.
     */
    handleResolveQueryLoadSuccess = (response: any) => {
        const queryData = response?.data?.data;
        const loadedQueryItem = this.queryUtils.convertQueryResponeToFormData(queryData);
        const resolveQueryCategory = loadedQueryItem.queryCategoryId || "";
        const resolveResolutionCategory = loadedQueryItem.queryResolutionCategoryId || "";
        const queryCategoryDescription = this.queryUtils.getFreeTextDescription(loadedQueryItem.queryCategoryDescription, resolveQueryCategory, this.state.queryCategoryLookUp);
        const queryResolutionCategoryDescription = this.queryUtils.getFreeTextDescription(loadedQueryItem.queryResolutionCategoryDescription, resolveResolutionCategory, this.state.queryResolutionCategoryLookUp);

        this.setState({
            resolveQueryItem: {
                ...loadedQueryItem,
                queryCategoryDescription,
                queryResolutionCategoryDescription
            },
            resolveQueryCategory,
            resolveQueryCategoryOther: queryCategoryDescription,
            resolveResolutionCategory,
            resolveResolutionCategoryOther: queryResolutionCategoryDescription,
            onQueryRaising: true,
            loadPanelVisible: false
        });
    }

    /**
     * Handles failures while loading the full query details for the Resolve popup.
     */
    handleResolveQueryLoadFailure = () => {
        this.setState({
            loadPanelVisible: false
        });
        notify({ message: "Unable to load query details", width: 500, shading: true }, 'error', 600);
    }

    showQueryPopUp = () => {
        this.setState({
            onQueryRaising: true
        });
    }
    closeQueryBox = () => {
        this.setState({
            onQueryRaising: false,
            resolveQueryCategory: "",
            resolveQueryCategoryOther: "",
            resolveResolutionCategory: "",
            resolveResolutionCategoryOther: ""
        });
    };

    getFilteredQueryCategoryLookUp = () => {
        return this.filterQueryCategoryLookUp(this.state.queryCategoryLookUp, this.state.resolveQueryItem.app || "");
    }

    getFilteredQueryResolutionCategoryLookUp = () => {
        return this.filterQueryResolutionCategoryLookUp(this.state.queryResolutionCategoryLookUp, this.state.resolveQueryItem.app || "");
    }

    // Categories are filtered by app, so changing the app clears any category picked for the previous one.
    handleResolveAppChange = (e: SelectBoxOnValueChangedEvent) => {
        if (e.event === undefined) return;
        this.setState({
            resolveQueryItem: {
                ...this.state.resolveQueryItem,
                app: e.value,
                queryCategoryId: "",
                queryCategoryDescription: "",
                queryResolutionCategoryId: "",
                queryResolutionCategoryDescription: ""
            },
            resolveQueryCategory: "",
            resolveQueryCategoryOther: "",
            resolveResolutionCategory: "",
            resolveResolutionCategoryOther: ""
        });
    }

    // The category text boxes are free text only - the selected item is already sent by id.
    handleResolveQueryCategoryChange = (e: SelectBoxOnValueChangedEvent) => {
        if (e.event === undefined) return;
        this.setState({
            resolveQueryCategory: e.value,
            resolveQueryItem: {
                ...this.state.resolveQueryItem,
                queryCategoryId: e.value
            }
        });
    }

    handleResolveResolutionCategoryChange = (e: SelectBoxOnValueChangedEvent) => {
        if (e.event === undefined) return;
        this.setState({
            resolveResolutionCategory: e.value,
            resolveQueryItem: {
                ...this.state.resolveQueryItem,
                queryResolutionCategoryId: e.value
            }
        });
    }

    isResolveFormValid = () => {
        const queryCategory = this.getFilteredQueryCategoryLookUp().find((item) => String(item.id) === String(this.state.resolveQueryCategory));
        const resolutionCategory = this.getFilteredQueryResolutionCategoryLookUp().find((item) => String(item.id) === String(this.state.resolveResolutionCategory));
        return !!this.state.resolveQueryItem.resolutionReason?.trim()
            && !!this.state.resolveQueryItem.app
            && !!queryCategory
            && !!resolutionCategory
            && (queryCategory.value !== "Miscellaneous" || !!this.state.resolveQueryCategoryOther?.trim())
            && (resolutionCategory.value !== "Other" || !!this.state.resolveResolutionCategoryOther?.trim());
    }

    handleResolveQueryCategoryOtherChange = (e: any) => {
        this.setState({
            resolveQueryCategoryOther: e.value,
            resolveQueryItem: {
                ...this.state.resolveQueryItem,
                queryCategoryDescription: e.value
            }
        });
    }

    handleResolveResolutionCategoryOtherChange = (e: any) => {
        this.setState({
            resolveResolutionCategoryOther: e.value,
            resolveQueryItem: {
                ...this.state.resolveQueryItem,
                queryResolutionCategoryDescription: e.value
            }
        });
    }

    handleQuerySubmissionFailure = () => {
        this.setState({
            loadPanelVisible: false,
        });
        notify({ message: "Query Resolving failed", width: 500, shading: true }, 'error', 600);
    };

    /**
     * Normalizes backend values for new activity into a boolean.
     */
    hasNewActivity = (value: any): boolean => {
        return value === true || value === "true" || value === 1 || value === "1";
    }

    renderDataRow = (rowInfo: any) => {
        let finalFormattedLastUpdatedDate: string = "";
        let finalFormattedDate: string = "";
        let formattedDateFrom :string = "";
        if (rowInfo.data.date_Created) {
            let dateCreatedTime = rowInfo.data.date_Created;
            let dateCreatedTimeLocal = new Date(dateCreatedTime);
            let formattedTime = this.sharedUtils.convertDateTimeStringToHHMM(dateCreatedTimeLocal.toString());
            let formattedDate = this.sharedUtils.convertDateToString(dateCreatedTimeLocal);
            finalFormattedDate = `${formattedDate} ${formattedTime}`;
        }
        if(rowInfo.data.lastUpdated_DateTime){
            let lastUpdatedTime = rowInfo.data.lastUpdated_DateTime;
            let lastUpdatedTimeLocal = new Date(lastUpdatedTime);
            let formattedLastUpdatedTime = this.sharedUtils.convertDateTimeStringToHHMM(lastUpdatedTimeLocal.toString());
            let formattedLastUpdatedDate = this.sharedUtils.convertDateToString(lastUpdatedTimeLocal);
            finalFormattedLastUpdatedDate = `${formattedLastUpdatedDate} ${formattedLastUpdatedTime}`;
        }

        if (rowInfo.data.billableItem?.dateFrom) {
            let dateFrom = rowInfo.data.billableItem?.dateFrom;
            let dateFromTimeLocal = new Date(dateFrom);
            let formattedTime = this.sharedUtils.convertDateTimeStringToHHMM(dateFromTimeLocal.toString());
            let formattedDate = this.sharedUtils.convertDateToString(dateFromTimeLocal);
            // formattedDateFrom = `${formattedDate} ${formattedTime}`;
            formattedDateFrom = `${formattedDate}`;
        }
        let billableItemId: string = "";
        let linkedId: string = "";
        let disablerelatedItemIcon: boolean = true;
        if (rowInfo.data.billableItemId) {
            billableItemId = rowInfo.data.billableItemId;
        }

        if (rowInfo.data.linkedId && (rowInfo.data.queryTypeLookUp.id.toString() == queryTypes.AddJob || rowInfo.data.queryTypeLookUp.id.toString() == queryTypes.PaymentRequest)) {
            linkedId = rowInfo.data.linkedId
        }
        if (rowInfo.data.queryTypeLookUp.id.toString() == queryTypes.AddJob || rowInfo.data.queryTypeLookUp.id.toString() == queryTypes.PaymentRequest || rowInfo.data.queryTypeLookUp.id.toString() == queryTypes.BillableItem || rowInfo.data.queryTypeLookUp.id.toString() == queryTypes.CostReport) {
            disablerelatedItemIcon = false;
        }
        let iconToShow: any;
        if (rowInfo.data.caseStatusLU.case_Status_ID && rowInfo.data.caseStatusLU.case_Status_ID == queryStatusType.Resolved) {
            iconToShow = faCheckDouble;
        }
        else {
            iconToShow = faSquare;
        }
        return (
            <>
                <tr>
                    <td rowSpan={2}>                        
                        <div className="d-flex justify-content-between align-items-center">
                            <Link title="Edit"
                                className={"icon-btn"}
                                to={{
                                    pathname: "/QueryManageForm",
                                    state: {
                                        id: rowInfo.data.case_ID,
                                        isView: false,
                                        pointOfNavigation: "queryGrid"
                                    },
                                }}
                            >
                                <FontAwesomeIcon icon={faPen} /></Link>
                        </div>
                    </td>
                    <td>
                        <div className="d-flex justify-content-between align-items-center">
                            <Link title="View"
                                className={"icon-btn"}
                                to={{
                                    pathname: "/QueryManageForm",
                                    state: {
                                        id: rowInfo.data.case_ID,
                                        isView: true,
                                        pointOfNavigation: "queryGrid"
                                    },
                                }}
                            >
                                <FontAwesomeIcon icon={faEye} /></Link>
                        </div>
                    </td>
                    <td>
                        <div className="d-flex justify-content-between align-items-center">

                            <button
                                className={"without-border-button"}
                                onClick={(e: MouseEvent) => {
                                    e.preventDefault();
                                    this.handleResolveOnClick(rowInfo);
                                }}
                            >
                                <FontAwesomeIcon icon={iconToShow} />
                            </button>
                        </div>
                    </td>
                    <td>
                        <div className="d-flex justify-content-between align-items-center">
                            {(() => {
                                const hasNewActivity = this.hasNewActivity(rowInfo.data.newActivity);
                                return (
                            <button
                                className={"without-border-button"}
                                onClick={(e: MouseEvent) => {
                                    e.preventDefault();
                                    this.handleNewActivityOnClick(rowInfo.data.case_ID, hasNewActivity);
                                }}
                                title={hasNewActivity ? "New Activity" : "No New Activity"}
                                aria-label={hasNewActivity ? "New Activity" : "No New Activity"}
                                aria-pressed={hasNewActivity}
                            >
                                <FontAwesomeIcon
                                    icon={hasNewActivity ? faBell : faBellSlash}
                                    style={hasNewActivity ? {} : {color: '#979ca1'}}
                                />
                            </button>
                                );
                            })()}
                        </div>
                    </td>
                    <td>
                        <div className="d-flex justify-content-between align-items-center">
                            {billableItemId ?
                                <button
                                    className={disablerelatedItemIcon ? "disabled icon-btn without-border-button" : "without-border-button"}
                                    onClick={(e: MouseEvent) => {
                                        e.preventDefault();
                                        this.showRelatedItemPopup(billableItemId);
                                    }}
                                    disabled={disablerelatedItemIcon}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                </button> :
                                <button
                                    className={disablerelatedItemIcon ? "disabled icon-btn without-border-button" : "without-border-button"}
                                    onClick={(e: MouseEvent) => {
                                        e.preventDefault();
                                        window.open(`/MatchedPopUpPage?filterBy=${linkedId}`, "Related Payment Request/ Artist Job Notification",
                                            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=1050,height=400,left=100,top=100")
                                    }}
                                    disabled={disablerelatedItemIcon} >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                </button>}
                        </div>
                    </td>
                    <td> <TagCell data={rowInfo} i18n={rowInfo} tReady={false} t={rowInfo} /> </td>
                    <td className="datagrid__text-cell">{rowInfo.data.taggedUser?.name}</td>
                    <td className="datagrid__text-cell">{rowInfo.data.caseStatusLU.case_Status_Value}</td>
                    <td className="datagrid__text-cell">{rowInfo.data.queryTypeLookUp.value}</td>
                    <td className="datagrid__text-cell">{this.internalOnlyDisplay(rowInfo.data)}</td>
                    <td className="datagrid__text-cell">{this.firstResponseDisplay(rowInfo.data)}</td>
                    <td className="datagrid__text-cell">{this.resolutionDateDisplay(rowInfo.data)}</td>
                    <td className="datagrid__text-cell">{this.queryTypeDisplay(rowInfo.data)}</td>
                    <td className="datagrid__text-cell">{this.resolutionTypeDisplay(rowInfo.data)}</td>
                    <td className="datagrid__text-cell">{rowInfo.data.billableItem?.serviceSubTypeLookUp?.value ? rowInfo.data.billableItem?.serviceSubTypeLookUp?.value:''}</td>
                    <td className="datagrid__text-cell">{formattedDateFrom}</td>
                    {/* <td className="datagrid__text-cell">{rowInfo.data.billableItem?.dateFrom ? this.sharedUtils.convertTDateFormatToFormatedDate(rowInfo.data.billableItem?.dateFrom): ''}</td>  */}
                    <td className="datagrid__text-cell">{rowInfo.data.billableItem?.name ? rowInfo.data.billableItem?.name : ''}</td>
                    <td className="datagrid__text-cell">{finalFormattedDate}</td>
                    {/* <td className="datagrid__text-cell">{rowInfo.data.queryRaisedBy}</td> */}
                    <td className="datagrid__text-cell">{this.colorStatusForRaisedBy(rowInfo)}</td>
                    <td className="datagrid__text-cell">{rowInfo.data.clientBusinessEntity ? rowInfo.data.clientBusinessEntity.shortName : ""}</td>
                    <td className="datagrid__text-cell">{this.clientServiceDisplay(rowInfo)}</td>
                    {/* <td className="datagrid__text-cell">{rowInfo.data.venue ? rowInfo.data.venue.venueName : ""}</td> */}
                    <td className="datagrid__text-cell">{rowInfo.data.venue ? this.venueCellDisplayContent(rowInfo): ''}</td>
                    <td className="datagrid__text-cell">{this.onboardedCellDisplayContent(rowInfo)}</td>
                    <td className="datagrid__text-cell">{rowInfo.data.serviceTypeLookUp ? rowInfo.data.serviceTypeLookUp.value : ""}</td>
                    <td className="datagrid__text-cell">
                        {this.titleCellDisplayContent(rowInfo)}
                    </td>
                    <td className="datagrid__text-cell">{this.providerCellDisplayContent(rowInfo)}</td>
                    <td className="datagrid__text-cell">{rowInfo.data.providerBusinessEntity?.id}</td>
                    <td className="datagrid__text-cell">{this.providerServiceDisplay(rowInfo)}</td>
                    <td className="datagrid__text-cell">{this.resolutionReasonCellDisplayContent(rowInfo)}</td>
                    <td className="datagrid__text-cell">{this.internalCommentsCellDisplayContent(rowInfo)}</td>
                    <td className="datagrid__text-cell">{rowInfo.data.raisedByContactName}</td>
                    <td className="datagrid__text-cell">{rowInfo.data.raisedByContactTelNumber}</td>
                    <td className="datagrid__text-cell">{finalFormattedLastUpdatedDate}</td>
                    <td className="datagrid__text-cell">{rowInfo.data.user ? rowInfo.data.user.name : ""}</td>
                    <td rowSpan={2} className="datagrid__text-cell">{rowInfo.data.case_ID}</td>
                    <td rowSpan={2} className="datagrid__text-cell">{rowInfo.data.linkedCaseID}</td>
                </tr>
                <tr>
                    <td className="datagrid__description-row datagrid__text-description-cell" colSpan={15}><div>{rowInfo.data.query_Description}</div></td>
                </tr>
            </>
        )
    }

    onExporting = (e: onExportingEvent) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        let maxColIndex = 0;
        const descriptionsByRow = new Map<number, string>();

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            customizeCell: ({ gridCell, excelCell }: any) => {
                if (gridCell.rowType === 'header' && excelCell.col > maxColIndex) {
                    maxColIndex = excelCell.col;
                }
                if (gridCell.rowType === 'data' && !descriptionsByRow.has(excelCell.row)) {
                    descriptionsByRow.set(excelCell.row, gridCell.data?.query_Description ?? '');
                }
            }
        }).then(() => {

            // Append description as an extra column after all exported columns
            const descColIdx = maxColIndex + 1;
            const headerCell = worksheet.getCell(1, descColIdx);
            headerCell.value = 'DESCRIPTION';
            headerCell.font = { bold: true };
            descriptionsByRow.forEach((description, rowNum) => {
                worksheet.getCell(rowNum, descColIdx).value = description;
            });

            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx");
            });
        });
        e.cancel = true;
    }

    titleCellDisplayContent = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showInfoTitle(cellInfo.data.query_Title);
                    }}
                    className="approval-query-column"
                    to="#"

                >
                    {cellInfo.data.query_Title
                        ? cellInfo.data.query_Title.length > 16
                            ? `${cellInfo.data.query_Title.substring(0, 16)}...`
                            : cellInfo.data.query_Title
                        : ""}
                </Link>
            </div>
        );
    };

    internalCommentsCellDisplayContent = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showInfoInternalComments(cellInfo.data.internal_Comments);
                    }}
                    className="approval-query-column"
                    to="#"

                >
                    {cellInfo.data.internal_Comments
                        ? cellInfo.data.internal_Comments.length > 16
                            ? `${cellInfo.data.internal_Comments.substring(0, 16)}...`
                            : cellInfo.data.internal_Comments
                        : ""}
                </Link>
            </div>
        );
    };
    resolutionReasonCellDisplayContent = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showInfoResolutionReason(cellInfo.data.resolution_Reason);
                    }}
                    className="approval-query-column"
                    to="#"

                >
                    {cellInfo.data.resolution_Reason
                        ? cellInfo.data.resolution_Reason.length > 16
                            ? `${cellInfo.data.resolution_Reason.substring(0, 16)}...`
                            : cellInfo.data.resolution_Reason
                        : ""}
                </Link>
            </div>
        );
    };
    showInfoTitle = (title: string) => {
        this.setState({
            titlePopupVisible: true,
            title: title,
        });
    };

    hideInfoTitle = () => {
        this.setState({
            titlePopupVisible: false
        });
    };
    showInfoInternalComments = (comments: string) => {
        this.setState({
            internalCommentsPopupVisible: true,
            internalComments: comments
        });
    };

    hideInfoInternalComments = () => {
        this.setState({
            internalCommentsPopupVisible: false
        });
    };
    showInfoResolutionReason = (reason: string) => {
        this.setState({
            resolutionReasonPopUpVisible: true,
            resolutionReason: reason
        });
    };

    hideInfoResolutionReason = () => {
        this.setState({
            resolutionReasonPopUpVisible: false
        });
    };

    onQuerySubmission = () => {
        if (!this.isResolveFormValid()) {
            alert("Please enter the resolution reason before pushing the submit button", "Resolve Query");
        } else {
            this.setState({
                loadPanelVisible: true,
            });
            let convertedresolveQueryItem = this.queryUtils.convertFormDataToQueryRequest(this.state.resolveQueryItem, "");
            this.queryService.postResolveQueryRequestFormData(convertedresolveQueryItem)
                .then(() => this.handleQuerySubmissionSuccess())
                .catch(this.handleQuerySubmissionFailure);
        }
    }
    handleQuerySubmissionSuccess = () => {
        this.setState({
            loadPanelVisible: false
        });
        this.closeQueryBox();
        notify({ message: "Thank you - Query Resolved", width: 500, shading: true }, 'success', 600);
        setTimeout(this.loadDataSource, 2000);

    };
    handleChangeQueryComments = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.value != undefined) {
            this.setState({
                resolveQueryItem: {
                    ...this.state.resolveQueryItem,
                    resolutionReason: dxValueChange.value
                }
            });
        }
    }

    showInfoProvider = (clientId: string, venueId: string, serviceTypeId: string, businessEntityId: string,data:any) => {
        let type = data?.providerType || '';
        let serviceName = data?.serviceTypeLookUp?.value;
        //let serviceName = ''
        // if (type) {
        //     if (this.state.providerType == 'artist') {
        //         serviceName = 'Entertainment';
        //     } else if (this.state.providerType == 'provider') {
        //         serviceName = 'viewProviders';
        //     }
        // }
        this.setState({
            clientId: clientId,
            venueId: venueId,
            serviceId: serviceTypeId,
            businessEntityId: businessEntityId,
            serviceName : serviceName,
            providerType:type?.toLowerCase()
        });

        if (type) {//if (type == 'artist' || type == 'provider') {
            this.setState({
                providerPopupVisibleEntertainment: true
            });
        } 
        // else {
        //     this.setState({
        //         providerPopupVisibleOther: true
        //     }); 
        // }
        // if (serviceTypeId == "10") {
        //     this.setState({
        //         providerPopupVisibleOther: true,
        //     });
        // }
        // else {
        //     this.setState({
        //         providerPopupVisibleEntertainment: true,
        //     });            
        // }
        
        // if(serviceTypeId == "30"){
        //     this.setState({
        //         providerPopupVisibleEntertainment: true,
        //     });
        // }
        // else{
        //     this.setState({
        //         providerPopupVisibleOther: true,
        //     }); 
        // }
    };

    providerCellDisplayContent = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showInfoProvider(cellInfo.data.clientBusinessEntity?.id, cellInfo.data.venue?.id, cellInfo.data.serviceTypeLookUp?.id, cellInfo.data.providerBusinessEntity?.id,cellInfo.data);
                    }}
                    className="approval-query-column"
                    to="#"
                >
                    {cellInfo.data.providerBusinessEntity?.shortName}
                </Link>
            </div>
        );
    };

    raisedByCellDisplayContent = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showInfoProvider(cellInfo.data.clientBusinessEntity?.id, cellInfo.data.venue?.id, cellInfo.data.serviceTypeLookUp?.id, cellInfo.data.providerBusinessEntity?.id,cellInfo.data);
                    }}
                    className="approval-query-column"
                    to="#"
                >
                    {cellInfo?.data?.queryRaisedBy}
                </Link>
            </div>
        );
    };

    formatGridDate = (value: any): string => {
        if (!value) {
            return "";
        }

        const date = new Date(value);
        if (isNaN(date.getTime())) {
            return value;
        }

        const formattedDate = this.sharedUtils.convertDateToString(date);
        const formattedTime = this.sharedUtils.convertDateTimeStringToHHMM(date.toString());
        return `${formattedDate} ${formattedTime}`;
    }

    internalOnlyDisplay = (data: any): string => {
        const value = data.internalOnly ?? data.internal_Only;
        return value === true || value === 1 || String(value).toLowerCase() === "true" || String(value) === "1" ? "Yes" : "No";
    }

    firstResponseDisplay = (data: any): string => {
        return this.formatGridDate(data.firstResponseDateTime || data.responseTime || data.firstResponseTime);
    }

    resolutionDateDisplay = (data: any): string => {
        return this.formatGridDate(data.resolvedDate || data.resolutionDate);
    }

    firstResponseCellValue = (data: any) => {
        return data.firstResponseDateTime || data.responseTime || data.firstResponseTime || null;
    }

    resolvedDateCellValue = (data: any) => {
        return data.resolvedDate || data.resolutionDate || null;
    }

    queryTypeDisplay = (data: any): string => {
        return data.queryCategoryDescription || (typeof data.queryCategory === "string" ? data.queryCategory : data.queryCategory?.value) || data.queryType || data.queryCategoryLookUp?.value || "";
    }

    resolutionTypeDisplay = (data: any): string => {
        return data.queryResolutionCategoryDescription || (typeof data.queryResolutionCategory === "string" ? data.queryResolutionCategory : data.queryResolutionCategory?.value) || data.resolutionType || data.queryResolutionCategoryLookUp?.value || "";
    }

    onboardedCellDisplayContent = (cellInfo: any) => {
        let onboardedVal = "";
        onboardedVal = cellInfo.data.venue ? cellInfo.data.venue?.onboarded : cellInfo.data.onboarded;
        let valToShow: string = "";
        if (onboardedVal) {
            valToShow = "Yes";
        }
        else {
            valToShow = "No";
        }
        return (
            <div className="container-fluid">
                {valToShow}
            </div>
        );

    }

    hidePopup = (isPopupVisible: boolean) => {
        this.setState({
            isVisibleManageShiftPopup: isPopupVisible
        });
    }

    hideInfoProvider = (e: any) => {       
        this.setState({
            providerPopupVisibleOther: false,
        });  
    };

    handlePopUpClose = (flag:boolean, editmode: string) => {        
        this.isEditMode = editmode;
        this.setState({
            providerPopupVisibleEntertainment: flag,
        });
    }

    hideInfoProviderArtistProfile = (e: any) => {
        e.cancel = true;
        if(this.isEditMode == "editMode"){
            confirm("<div class='text-center'>Close screen without saving?</div>", "Close").then((hasConfirmed) => {
                if (hasConfirmed) {
                    this.setState({
                        providerPopupVisibleEntertainment: false,
                    });
                    this.isEditMode = "";
                }
            });
        }
        else{
            this.setState({
                providerPopupVisibleEntertainment: false,
            });  
        }
    };

    getServiceType = () =>{
        let serviceType = this.state.serviceName;
            if(this.state.providerType){
                if(this.state.providerType == 'artist'){
                    serviceType = 'Entertainment';
                } else if(this.state.providerType == 'provider'){
                    //if(!serviceType){
                        serviceType = 'viewProviders'; //check for general queries where no service available
                    //}
                }
            } 
        return serviceType;
    }

    getTitleForPopup = () => {
        //let serviceType = this.state.serviceName;
        let title = '';
        if(this.state.providerType){
            if(this.state.providerType == 'artist'){
             title = "Artist Details" 
            } else if(this.state.providerType == 'provider'){
                title = "Provider Details"
            }
        }
        return title;
    }

    clientServiceDisplay = (cellInfo: any) => {
        return (
            <span>
                <div className="mb-0">
                    {cellInfo.data.clientServices
                        ? cellInfo.data.clientServices.map((item: any, uniqueKey: number) => {
                            return (
                                <>
                                    <div key={uniqueKey}>
                                        {item}
                                    </div>
                                </>
                            );
                        })
                        : null}
                </div>
            </span>
        );
    }

    providerServiceDisplay = (cellInfo: any) => {
        return (
            <span>
                <div className="mb-0">
                    {cellInfo.data.providerServices
                        ? cellInfo.data.providerServices.map((item: any, uniqueKey: number) => {
                            return (
                                <>
                                    <div key={uniqueKey}>
                                        {item}
                                    </div>
                                </>
                            );
                        })
                        : null}
                </div>
            </span>
        );
    }
    showInfoVenue = (clientId: string, venueId: string,data:any) => {
        let type = data?.type || 'artist';
        let serviceName = data?.serviceTypeLookUp?.value || '';
        let serviceTypeId = data?.serviceTypeLookUp?.id || '';
        let businessEntityId = data?.clientBusinessEntity?.id
        this.setState({
            venuePopupVisible: true,
            clientId: clientId,
            venueId: venueId,
            serviceId: serviceTypeId,
            businessEntityId: businessEntityId,
            serviceName : serviceName,
            type:type?.toLowerCase()
        });
    };
    venueCellDisplayContent = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showInfoVenue(cellInfo.data.clientBusinessEntity?.id, cellInfo.data.venue?.id,cellInfo.data);
                    }}
                    className="approval-query-column"
                    to="#"
                >
                    {cellInfo.data?.venue?.venueName}
                </Link>
            </div>
        );
    };


    hideInfoVenue = () => {
        this.setState({
            venuePopupVisible: false,
        });
    };

    /**
     * Opens activity details for a case when new activity exists.
     */
    handleNewActivityOnClick = (rowId: string, hasNewActivity: boolean) => {
        if (!rowId) {
            return;
        }

        this.setState({ activityPopupLoading: true });
        this.queryService.getQueryCardItem(rowId)
            .then(this.handleActivityQuerySuccess)
            .catch(this.handleActivityQueryFailure);
    };

    /**
     * Loads activity entries from query detail response and displays the popup.
     */
    handleActivityQuerySuccess = (response: any) => {
        const queryData = response?.data?.data;
        const activityItems = Array.isArray(queryData?.activity) ? queryData.activity : [];

        this.setState({
            selectedQueryIdForActivity: queryData?.id || "",
            activityItems: activityItems,
            newActivityPopupVisible: true,
            activityPopupLoading: false
        });
    };

    /**
     * Handles activity detail load failures.
     */
    handleActivityQueryFailure = () => {
        this.setState({ activityPopupLoading: false });
        notify({ message: "Unable to load activity details", width: 500, shading: true }, 'error', 600);
    };

    /**
     * Closes the New Activity popup and resets loaded activity state.
     */
    hideNewActivityPopup = () => {
        this.setState({
            newActivityPopupVisible: false,
            selectedQueryIdForActivity: "",
            activityItems: []
        });
    };

    /**
     * Acknowledges activity by saving the query with newActivity set to false.
     */
    acknowledgeNewActivity = () => {
        const selectedQueryId = this.state.selectedQueryIdForActivity;
        if (!selectedQueryId) {
            this.hideNewActivityPopup();
            return;
        }

        this.setState({ activityPopupLoading: true });
        this.queryService.getQueryCardItem(selectedQueryId)
            .then((response: any) => {
                const queryData = response?.data?.data;
                const viewData = this.queryUtils.convertQueryResponeToFormData(queryData);
                const request = this.queryUtils.convertFormDataToQueryRequest({
                    ...viewData,
                    newActivity: false
                }, "");

                return this.queryService.postQueryRequestFormData(request);
            })
            .then(() => {
                this.setState({ activityPopupLoading: false });
                this.hideNewActivityPopup();
                notify({ message: "Activity acknowledged", width: 500, shading: true }, 'success', 600);
                this.loadDataSource();
            })
            .catch(() => {
                this.setState({ activityPopupLoading: false });
                notify({ message: "Unable to acknowledge activity", width: 500, shading: true }, 'error', 600);
            });
    };

    onCustomGridLoad = () => {
        const gridState: any = CookieService.loadDXGridConfiguration(DXGridCookieKeyTypes.queryGrid);

        if (!gridState) {
            return gridState;
        }

        const { columns, ...restGridState } = gridState;
        return restGridState;
    }

    onCustomGridSave = (gridState: any) => {
        const { columns, ...sanitizedGridState } = gridState || {};

        CookieService.saveDXGridConfiguration(DXGridCookieKeyTypes.queryGrid, sanitizedGridState);
    }

    saveLinkedQueries = () => {
        let selectedRowsData = this.dataGrid?.instance()?.getSelectedRowsData();
        let Ids:any = [];   
        let linkedId:any = [];   
        if(selectedRowsData.length > 0){
            this.setState({
                loadPanelVisible: true,
                isDisabled: false,
            });
            selectedRowsData.forEach((items: any) => {                 
                Ids.push(items.case_ID);
            });
            let queryId = this.props?.queryId ? this.props?.queryId : "";
            linkedId = Ids;            
            this.queryService
                .savelinkedQuery(queryId, linkedId)
                .then((response) => {
                    this.setState({
                        loadPanelVisible: false
                    });
                    this.dataGrid?.instance()?.clearSelection();
                    setTimeout(this.loadDataSource, 2000);
                })
                .catch(() => { throw 'Data Loading Error'; });
        }
    }


    renderManageShiftPopup = () => {
        return (
            <Popup
                // elementAttr={{
                //     class: "pending-request-panel__raise-query-pop-up",
                // }}
                visible={this.state.isVisibleManageShiftPopup}
                onHiding={this.closeManageShiftPopup}
                dragEnabled={false}
                hideOnOutsideClick={false}
                showTitle={true}
                showCloseButton={true}
                title="Related Item"
                defaultWidth="90%"
                defaultHeight="80%"
                resizeEnabled={true}
            >
                <ScrollView width="100%" height="100%">
                    <div>
                        {billableItemId ? <QuickAddShiftForm location={this.props.location} history={this.props.history} billableItemId={billableItemId} navigateFrom={"queryGrid"} hidePopup={this.hidePopup}></QuickAddShiftForm> : null}
                    </div>
                </ScrollView>
            </Popup>
        )
    }

    renderQueryFormPopup = () => {
        return (
            <Popup
                visible={this.state.isVisibleQueryPopup}
                onHiding={this.closeQueryFormPopup}
                dragEnabled={false}
                hideOnOutsideClick={false}
                showTitle={true}
                showCloseButton={true}
                title="Query"
                defaultWidth="90%"
                defaultHeight="80%"
                resizeEnabled={true}
            >
                <ScrollView width="100%" height="100%">
                    <div>
                        {queryFormId ? <QueryManageForm location={this.props.location} history={this.props.history} queryFormId={queryFormId} ></QueryManageForm> : null}
                    </div>
                </ScrollView>
            </Popup>
        )
    }

    onSelectionChanged = (value: DataGridOnSelectionChanged) => {
        if (value.selectedRowsData && value.selectedRowsData.length > 0) {
            this.setState({isDisabled:false});
        }
        else{
            this.setState({isDisabled:true});
        }
    };

    headerOfSelectedCell = () => {
        return <div>SELECT</div>;
    };
    colorStatusForRaisedBy = (cellInfo:any) =>{
        // let val = cellInfo?.data?.data?.queryRaisedBy;
        let raisedByVal = cellInfo?.data?.queryRaisedBy;
        let renderedVal =<div></div>
        if(raisedByVal){
            if(raisedByVal?.toLowerCase() =='client'){
                renderedVal = <div style={{color:'red'}}>{`${raisedByVal}`}</div>
            } else if(raisedByVal?.toLowerCase() =='provider'){
                if(cellInfo?.data?.providerType){
                    renderedVal = this.raisedByCellDisplayContent(cellInfo);
                }
                else {
                     renderedVal = <div style={{color:'blue'}}>{`${raisedByVal}`}</div>
                }
            } else if(raisedByVal?.toLowerCase() =='company'){
                renderedVal = <div style={{color:'black'}}>{`${raisedByVal}`}</div>
            } else {
                renderedVal = <div>{`${raisedByVal}`}</div>
            }
        }
        return renderedVal;
    }

    render() {
        const filteredQueryCategoryLookUp = this.getFilteredQueryCategoryLookUp();
        const filteredQueryResolutionCategoryLookUp = this.getFilteredQueryResolutionCategoryLookUp();
        return (
            <>  
                <div className="grid-info__button-container text-center text-lg-left" hidden={this.props?.navigateFrom !== "queryform"}>
                    <button className={"btn btn-primary btn--large col-12 col-sm-6 col-xl-3 mb-3"} onClick={this.saveLinkedQueries} disabled={this.state.isDisabled}>
                        Link Queries
                    </button>
                </div> 
                <LightModePageTemplate>
                    { this.props?.navigateFrom == "queryform" ?    
                            <DataGrid
                                elementAttr={this.gridElementAttr}
                                dataSource={this.state.dataSource}
                                showBorders={false}
                                showColumnLines={false}
                                allowColumnReordering={false}
                                allowColumnResizing={true}
                                columnAutoWidth={false}
                                columnResizingMode={"widget"}
                                hoverStateEnabled={true}
                                remoteOperations={this.remoteOperations}
                                // wordWrapEnabled={true}
                                onSelectionChanged={this.onSelectionChanged}
                                noDataText={"No queries found for the filters used"}
                                ref={(ref) => { this.dataGrid = ref; }}
                                dataRowComponent={QueryGridRenderDataRow}
                                className="datagrid"
                            >
                                <Paging defaultPageSize={10} />
                                <Pager showPageSizeSelector={true} allowedPageSizes={this.allowedPageSizes} showInfo={true} />
                            <HeaderFilter visible={true}>
                                <Search enabled={true} />
                            </HeaderFilter>
                                <FilterRow visible={true} applyFilter="auto" />
                                <GroupPanel visible={true} />
                                <FilterPanel visible={true} />
                                <SearchPanel visible={true} placeholder={"Search"} />
                                <Scrolling useNative={true} showScrollbar={"always"} />
                                <Selection mode="multiple" selectAllMode="allPages" showCheckBoxesMode="always"/>

                                <Column headerCellRender={this.headerOfSelectedCell} type="selection" width={50}/>   
                                <Column
                                    caption="RELATED ITEM"
                                    allowExporting={false}
                                    width={100}
                                />
                                <Column
                                    caption="TAG ME"
                                    cellComponent={TagCell}
                                    width={80}
                                ></Column>
                                <Column
                                    dataField="taggedUser.name"
                                    caption="TAGGED"
                                    width={100}
                                />
                                <Column
                                    dataField="caseStatusLU.case_Status_Value"
                                    caption="STATUS"
                                    width={100}
                                />
                                <Column
                                    dataField="queryTypeLookUp.value"
                                    caption="TYPE"
                                    width={100}
                                />
                                <Column
                                    dataField="internalOnly"
                                    caption="INTERNAL ONLY"
                                    calculateCellValue={this.internalOnlyDisplay}
                                    width={120}
                                />
                                <Column
                                    dataField="firstResponseDateTime"
                                    caption="FIRST RESPONSE"
                                    calculateCellValue={this.firstResponseCellValue}
                                    format="dd/MM/yyyy"
                                    dataType="date"
                                    width={150}
                                />
                                <Column
                                    dataField="resolvedDate"
                                    caption="RESOLUTION DATE"
                                    calculateCellValue={this.resolvedDateCellValue}
                                    format="dd/MM/yyyy"
                                    dataType="date"
                                    width={150}
                                />
                                <Column
                                    dataField="queryCategoryDescription"
                                    caption="QUERY TYPE"
                                    calculateCellValue={this.queryTypeDisplay}
                                    allowFiltering={true}
                                    allowSearch={true}
                                    allowSorting={true}
                                    dataType="string"
                                    width={140}
                                />
                                <Column
                                    dataField="queryResolutionCategoryDescription"
                                    caption="RESOLUTION TYPE"
                                    calculateCellValue={this.resolutionTypeDisplay}
                                    allowFiltering={true}
                                    allowSearch={true}
                                    allowSorting={true}
                                    dataType="string"
                                    width={160}
                                />
                                <Column
                                    dataField="date_Created"
                                    caption="DATE/TIME RAISED"
                                    format="dd/MM/yyyy"
                                    dataType="date"
                                    width={150}
                                />
                                <Column
                                    dataField="queryRaisedBy"
                                    caption="RAISED BY"
                                    allowFiltering={false}
                                    allowSearch={false}
                                    allowSorting={false}
                                    width={100}
                                />
                                <Column
                                    dataField="clientBusinessEntity.shortName"
                                    caption="CLIENT"
                                    width={120}
                                />
                                <Column
                                    caption="VENUE"
                                    dataField="venue.venueName"
                                    width={120}
                                />
                                <Column
                                    dataField="venue.onboarded"
                                    caption="ONBOARDED"
                                    width={145}
                                />
                                <Column
                                    caption="SERVICE"
                                    dataField="serviceTypeLookUp.value"
                                    width={100}
                                />
                                <Column
                                    dataField="query_Title"
                                    caption="TITLE"
                                    width={150}
                                />
                                <Column
                                    dataField="providerBusinessEntity.shortName"
                                    caption="PROVIDER"
                                    width={120}
                                />
                                <Column
                                    dataField="providerBusinessEntity.id"
                                    caption="PROVIDER ID"
                                    width={120}
                                />
                                <Column
                                    dataField="resolution_Reason"
                                    caption="RESOLUTION REASON"
                                    width={170}
                                />
                                <Column
                                    dataField="internal_Comments"
                                    caption="INTERNAL COMMENTS"
                                    width={170}
                                />
                                <Column
                                    dataField="raisedByContactName"
                                    caption="RAISED BY CONTACT"
                                    width={170}
                                />
                                <Column
                                    dataField="raisedByContactTelNumber"
                                    caption="CONTACT NO"
                                    width={130}
                                />
                                <Column
                                    dataField="LastUpdated_DateTime"
                                    caption="LAST UPDATED"
                                    format="dd/MM/yyyy"
                                    dataType="date"
                                    width={140} />

                                <Column
                                    dataField="user.name"
                                    caption="UPDATED BY"
                                    width={120}
                                />
                                <Column
                                    dataField="case_ID"
                                    caption="QUERY ID"
                                    width={100}
                                />
                                <Column
                                    dataField="linkedCaseID"
                                    caption="LINKED CASE ID"
                                    width={140}
                                />
                            </DataGrid>
                        : <DataGrid
                            elementAttr={this.gridElementAttr}
                            dataSource={this.state.dataSource}
                            showBorders={false}
                            showColumnLines={false}
                            allowColumnReordering={false}
                            allowColumnResizing={true}
                            columnAutoWidth={false}
                            columnResizingMode={"widget"}
                            hoverStateEnabled={true}
                            remoteOperations={this.remoteOperations}
                            onExporting={this.onExporting}
                            noDataText={"No queries found for the filters used"}
                            dataRowRender={this.renderDataRow}
                            ref={(ref) => { this.otherdataGrid = ref; }}
                            className="datagrid"
                        >
                            <Paging defaultPageSize={10} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={this.allowedPageSizes} showInfo={true} />
                            <HeaderFilter visible={true}>
                                <Search enabled={true} />
                            </HeaderFilter>
                            <Export enabled={true} />
                            <FilterRow visible={true} applyFilter="auto" />
                            <GroupPanel visible={true} />
                            <FilterPanel visible={true} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={this.onCustomGridLoad}
                                customSave={this.onCustomGridSave}
                            />
                            <SearchPanel visible={true} placeholder={"Search"} />
                            <Scrolling useNative={true} showScrollbar={"always"} />
                            <Column
                                caption="CHANGE"
                                allowExporting={false}
                                width={90}
                            />
                            <Column
                                caption="VIEW"
                                allowExporting={false}
                                width={70}
                            />
                            <Column
                                caption="RESOLVE?"
                                allowExporting={false}
                                width={80}
                            />
                            <Column
                                dataField="newActivity"
                                caption="NEW ACTIVITY"
                                name="newActivity"
                                allowFiltering={true}
                                allowHeaderFiltering={true}
                                headerFilter={this.newActivityHeaderFilter}
                                allowExporting={false}
                                width={145}
                            />
                            <Column
                                caption="RELATED ITEM"
                                allowExporting={false}
                                width={110}
                            />
                            <Column
                                caption="TAG ME"
                                cellComponent={TagCell}
                                width={80}
                            ></Column>
                            <Column
                                dataField="taggedUser.name"
                                caption="TAGGED"
                                width={100}
                            />
                            <Column
                                dataField="caseStatusLU.case_Status_Value"
                                caption="STATUS"
                                width={100}
                            />
                            <Column
                                dataField="queryTypeLookUp.value"
                                caption="TYPE"
                                width={100}
                            />
                            <Column
                                dataField="internalOnly"
                                caption="INTERNAL ONLY"
                                calculateCellValue={this.internalOnlyDisplay}
                                width={120}
                            />
                            <Column
                                dataField="firstResponseDateTime"
                                caption="FIRST RESPONSE"
                                calculateCellValue={this.firstResponseCellValue}
                                format="dd/MM/yyyy"
                                dataType="date"
                                width={150}
                            />
                            <Column
                                dataField="resolvedDate"
                                caption="RESOLUTION DATE"
                                calculateCellValue={this.resolvedDateCellValue}
                                format="dd/MM/yyyy"
                                dataType="date"
                                width={150}
                            />
                            <Column
                                dataField="queryCategoryDescription"
                                caption="QUERY TYPE"
                                calculateCellValue={this.queryTypeDisplay}
                                allowFiltering={true}
                                allowSearch={true}
                                allowSorting={true}
                                dataType="string"
                                width={140}
                            />
                            <Column
                                dataField="queryResolutionCategoryDescription"
                                caption="RESOLUTION TYPE"
                                calculateCellValue={this.resolutionTypeDisplay}
                                allowFiltering={true}
                                allowSearch={true}
                                allowSorting={true}
                                dataType="string"
                                width={160}
                            />
                            <Column
                                dataField="billableItem.serviceSubTypeLookUp.value"
                                caption="SUB TYPE"
                                width={100}
                            />
                            <Column
                                dataField="billableItem.dateFrom"
                                caption="DATE FROM"
                                // calculateSortValue={(rowData: any) => {
                                //     return this.sharedUtils.convertTDateFormatToFormatedDate(rowData.billableItem?.dateFrom);
                                // }}
                                // calculateCellValue={(rowData: any) => {
                                //     return this.sharedUtils.convertTDateFormatToFormatedDate(rowData.billableItem?.dateFrom);
                                // }}
                                format="dd/MM/yyyy"
                                dataType="date"
                                width={110}
                            />
                            <Column
                                dataField="billableItem.name"
                                caption="NAME"
                                width={120}
                            />
                            <Column
                                dataField="date_Created"
                                caption="DATE/TIME RAISED"
                                format="dd/MM/yyyy"
                                dataType="date"
                                width={150}
                            />
                            <Column
                                dataField="queryRaisedBy"
                                caption="RAISED BY"
                                allowFiltering={false}
                                allowSearch={false}
                                allowSorting={false}
                                width={100}
                            />
                            <Column
                                dataField="clientBusinessEntity.shortName"
                                caption="CLIENT"
                                width={120}
                            />
                            <Column
                                dataField="clientServices"
                                caption="CLIENT SERVICES"
                                allowFiltering={false}
                                allowSearch={false}
                                allowSorting={false}
                                //cellRender={this.clientServiceDisplay}
                                width={130}
                            />
                            <Column
                                caption="VENUE"
                                dataField="venue.venueName"
                                width={120}
                            />
                            <Column 
                                dataField="venue.onboarded" 
                                caption="ONBOARDED" 
                                width={145}
                            />
                            <Column
                                caption="SERVICE"
                                dataField="serviceTypeLookUp.value"
                                width={100}
                            />
                            <Column
                                dataField="query_Title"
                                caption="TITLE"
                                width={120}
                            />
                            <Column
                                dataField="providerBusinessEntity.shortName"
                                caption="PROVIDER"
                                width={120}
                            />
                            <Column
                                dataField="providerBusinessEntity.id"
                                caption="PROVIDER ID"
                                width={120}
                            />
                            <Column
                                dataField="providerServices"
                                caption="PROVIDER SERVICES"
                                allowFiltering={false}
                                allowSearch={false}
                                allowSorting={false}
                                //cellRender={this.providerServiceDisplay}
                                width={150}
                            />
                            <Column
                                dataField="resolution_Reason"
                                caption="RESOLUTION REASON"
                                width={170}
                            />
                            <Column
                                dataField="internal_Comments"
                                caption="INTERNAL COMMENTS"
                                width={170}
                            />
                            <Column
                                dataField="raisedByContactName"
                                caption="RAISED BY CONTACT"
                                width={170}
                            />
                            <Column
                                dataField="raisedByContactTelNumber"
                                caption="CONTACT NO"
                                width={130}
                            />
                            <Column
                                dataField="LastUpdated_DateTime"
                                caption="LAST UPDATED"
                                format="dd/MM/yyyy"
                                dataType="date"
                                width={140} />

                            <Column
                                dataField="user.name"
                                caption="UPDATED BY"
                                width={120}
                            />
                            <Column
                                dataField="case_ID"
                                caption="QUERY ID"
                                width={100}
                            />
                            <Column
                                dataField="linkedCaseID"
                                caption="LINKED CASE ID"
                                width={140}
                            />
                        </DataGrid>
                    }
                </LightModePageTemplate>
                <Popup
                    visible={this.state.titlePopupVisible}
                    onHiding={this.hideInfoTitle}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showTitle={true}
                    showCloseButton={true}
                    title={"TITLE"}
                    resizeEnabled={true}
                    width="550px"
                    height="auto"
                >
                    <ScrollView width="100%" height="100%">
                        <div>
                            <div className="card">
                                <div className="card-body">
                                    <p>{this.state.title}</p>
                                </div>
                            </div>
                        </div>
                    </ScrollView>
                </Popup>
                <Popup
                    visible={this.state.internalCommentsPopupVisible}
                    onHiding={this.hideInfoInternalComments}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showTitle={true}
                    showCloseButton={true}
                    title={"INTERNAL COMMENTS"}
                    resizeEnabled={true}
                    width="550px"
                    height="auto"
                >
                    <ScrollView width="100%" height="100%">
                        <div>
                            <div className="card">
                                <div className="card-body">
                                    <p>{this.state.internalComments}</p>
                                </div>
                            </div>
                        </div>
                    </ScrollView>
                </Popup>
                <Popup
                    visible={this.state.resolutionReasonPopUpVisible}
                    onHiding={this.hideInfoResolutionReason}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showTitle={true}
                    showCloseButton={true}
                    title={"RESOLUTION REASON"}
                    resizeEnabled={true}
                    width="550px"
                    height="auto"
                >
                    <ScrollView width="100%" height="100%">
                        <div>
                            <div className="card">
                                <div className="card-body">
                                    <p>{this.state.resolutionReason}</p>
                                </div>
                            </div>
                        </div>
                    </ScrollView>
                </Popup>
                <Popup
                    wrapperAttr={this.resolvePopupWrapperAttr}
                    visible={this.state.onQueryRaising}
                    onHiding={this.closeQueryBox}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title="Resolve Query?"
                    resizeEnabled={true}
                    maxWidth="500px"
                    height="700px"
                    maxHeight="90vh"
                >
                    <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadPanelVisible} />
                    <div className="container-fluid">
                        <div className="row mt-2"><div className="col-12">
                            <h6>Please enter a resolution reason<sup className="card-form__mandatory-symbol">*</sup></h6>
                            <TextArea value={this.state.resolveQueryItem.resolutionReason} onValueChanged={this.handleChangeQueryComments} />
                        </div></div>
                        <div className="row mt-3"><div className="col-12">
                            <h6>App<sup className="card-form__mandatory-symbol">*</sup></h6>
                            <DropDownFromLookupTable lookupTypeIndex={LookupTypeIndexes.userDeviceApp} onValueChanged={this.handleResolveAppChange} value={this.state.resolveQueryItem.app} />
                        </div></div>
                        <div className="row mt-3"><div className="col-12">
                            <h6>Please select query category<sup className="card-form__mandatory-symbol">*</sup></h6>
                            <SelectBox dataSource={filteredQueryCategoryLookUp} displayExpr="value" valueExpr="id" value={this.state.resolveQueryCategory} onValueChanged={this.handleResolveQueryCategoryChange} disabled={!this.state.resolveQueryItem.app} />
                        </div></div>
                        <div className="row mt-3"><div className="col-12">
                            <h6>Please state the query category<sup className="card-form__mandatory-symbol" hidden={filteredQueryCategoryLookUp.find((item) => String(item.id) === String(this.state.resolveQueryCategory))?.value !== "Miscellaneous"}>*</sup></h6>
                            <TextBox value={this.state.resolveQueryCategoryOther} onValueChanged={this.handleResolveQueryCategoryOtherChange} />
                        </div></div>
                        <div className="row mt-3"><div className="col-12">
                            <h6>Please select resolution category<sup className="card-form__mandatory-symbol">*</sup></h6>
                            <SelectBox dataSource={filteredQueryResolutionCategoryLookUp} displayExpr="value" valueExpr="id" value={this.state.resolveResolutionCategory} onValueChanged={this.handleResolveResolutionCategoryChange} disabled={!this.state.resolveQueryItem.app} />
                        </div></div>
                        <div className="row mt-3"><div className="col-12">
                            <h6>Please state the resolution category<sup className="card-form__mandatory-symbol" hidden={filteredQueryResolutionCategoryLookUp.find((item) => String(item.id) === String(this.state.resolveResolutionCategory))?.value !== "Other"}>*</sup></h6>
                            <TextBox value={this.state.resolveResolutionCategoryOther} onValueChanged={this.handleResolveResolutionCategoryOtherChange} />
                        </div></div>
                        <div className="row mt-4"><div className="col-12">
                            <button className="btn btn-primary btn--large" disabled={!this.isResolveFormValid()} onClick={(e: MouseEvent) => { e.preventDefault(); this.onQuerySubmission(); }}>
                                Resolve
                            </button>
                        </div></div>
                    </div>
                </Popup>
                <Popup
                    visible={this.state.providerPopupVisibleOther}
                    onHiding={this.hideInfoProvider}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showTitle={true}
                    showCloseButton={true}
                    title="Supplier Information & Venue Conditions"
                    resizeEnabled={true}
                >
                    <ScrollView width="100%" height="100%">
                        <SupplierInformationMainContent
                            clientId={this.state.clientId}
                            venueId={this.state.venueId}
                            serviceTypeId={this.state.serviceId}
                            navigationFromShift="SimpleShiftGrid"
                        ></SupplierInformationMainContent>
                    </ScrollView>
                </Popup>
                {
                    this.state.providerPopupVisibleEntertainment ? (
                        <Popup
                            visible={this.state.providerPopupVisibleEntertainment}
                            onHiding={this.hideInfoProviderArtistProfile}
                            dragEnabled={false}
                            hideOnOutsideClick={true}
                            showTitle={true}
                            showCloseButton={true}
                            title={this.getTitleForPopup()}
                            //title={this.state.serviceTypeId == "30" ? "Artist Details" : "Provider Details"}
                            resizeEnabled={true}
                        >
                            <ScrollView width="100%" height="100%">
                                <ArtistProfileComponent
                                    mode="view"
                                    id={this.state.businessEntityId}
                                    handlePopUpClose={this.handlePopUpClose}
                                    businessEntityId={this.state.businessEntityId}
                                    handleFeedbackUpdate = {()=>{return null}}
                                    handleAddArtist = {()=>{return null}}
                                    // serviceType={"Entertainment"}
                                    serviceType={this.getServiceType()}
                                ></ArtistProfileComponent>
                            </ScrollView>
                        </Popup>
                    ):(null)
                }
                {this.renderManageShiftPopup()}

                <Popup
                    visible={this.state.newActivityPopupVisible}
                    onHiding={this.hideNewActivityPopup}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showTitle={true}
                    showCloseButton={true}
                    titleRender={() => (
                        <div>
                            <div className="h2 mb-0" style={{ marginLeft: '20px' }}>Activity</div>
                            <small className="text-white" style={{ fontSize: '1.25rem', marginLeft: '20px' }}>Recent conversations and interactions</small>
                        </div>
                    )}
                    resizeEnabled={true}
                    width="1200px"
                    height="600px"
                >
                    <ScrollView width="100%" height="calc(100% - 60px)">
                        <div className="query-activity-popup">
                            <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.activityPopupLoading} />
                            {this.state.activityItems.length > 0 ? this.state.activityItems.map((item: QueryActivityItem, index: number) => (
                                <div className="query-activity-popup__item" key={`${item.query_Id}-${index}`}>
                                    <div className="query-activity-popup__item-header">
                                        <h4 className="query-activity-popup__title mb-0">{item.activity_Comments || "-"}</h4>
                                        <span className={`query-activity-popup__badge ${item.activity_external ? "query-activity-popup__badge--external" : "query-activity-popup__badge--internal"}`}>
                                            {item.activity_external ? "EXTERNAL" : "INTERNAL"}
                                        </span>
                                    </div>
                                    <div className="query-activity-popup__meta">
                                        <span className="query-activity-popup__bullet" aria-hidden="true">•</span>
                                        <strong>Activity Type:</strong> {item.activity_Type || "-"}
                                        <strong className="ml-3">By:</strong> {item.activity_LastUpdatedBy || "-"}
                                        <strong className="ml-3">Date Added:</strong> {this.sharedUtils.formatActivityDate(item.activity_LastUpdated)}
                                    </div>
                                </div>
                            )) : (
                                <div className="query-activity-popup__empty">No activity found for this query.</div>
                            )}
                        </div>
                    </ScrollView>
                    <div className="query-activity-popup__actions d-flex mt-3">
                        <button
                            className="btn btn-primary btn-sm btn--full-width mr-2 rounded-pill"
                            onClick={this.acknowledgeNewActivity}
                            disabled={this.state.activityPopupLoading}
                        >
                            <FontAwesomeIcon icon={faCheck} className="mr-2" />
                            ACKNOWLEDGE
                        </button>
                        <button
                            className="btn btn-outline-primary btn-sm btn--full-width rounded-pill"
                            onClick={this.hideNewActivityPopup}
                            disabled={this.state.activityPopupLoading}
                        >
                            CLOSE
                        </button>
                    </div>
                </Popup>
                <Popup
                    visible={this.state.venuePopupVisible}
                    onHiding={this.hideInfoVenue}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showTitle={true}
                    showCloseButton={true}
                    title="Client Information & Schedule"
                    resizeEnabled={true}
                >
                    <ScrollView width="100%" height="100%">
                        <ClientInformationMainContent
                            clientId={this.state.clientId}
                            venueId={this.state.venueId}
                            isShowByVenue={true}
                            serviceTypeId={this.state.serviceId}
                        ></ClientInformationMainContent>
                    </ScrollView>
                </Popup>
            </>

        );
    }
}

export default withTranslation()(QueryGrid);